import { http, HttpResponse } from 'msw';
import { mockTruktTmsApiUrl } from '../mocks';
import { InspectionTypeSearchResponse } from '../services/InspectionService';

export const handlers = [
  http.get(mockTruktTmsApiUrl('/inspections/types'), () => {
    return HttpResponse.json<InspectionTypeSearchResponse>({
      page: 0,
      rows: 10,
      total: 3,
      results: [
        {
          name: 'standard',
          isDefault: false,
        },
        {
          name: 'advanced',
          isDefault: false,
        },
        {
          name: 'AIAG',
          isDefault: false,
        },
      ],
    });
  }),
];
